.calendar {
  --ixf-calendar-width: var(--ixf-calendar-width-override, 388px);
  --ixf-calendar-background: var(--ixf-calendar-background-override, var(--ixf-color-background));
  --ixf-calendar-padding: var(--ixf-calendar-padding-override, var(--ixf-space-4));
  --ixf-calendar-border-radius: var(--ixf-border-radius-2);
  --ixf-calendar-box-shadow: var(--ixf-calendar-box-shadow-override, var(--ixf-box-shadow-dropdown));

  width: var(--ixf-calendar-width);
  max-width: calc(100dvw - 24px);
  position: relative;
  padding: var(--ixf-calendar-padding);
  background: var(--ixf-calendar-background);
  border-radius: var(--ixf-calendar-border-radius);
  box-shadow: var(--ixf-calendar-box-shadow);
}

.standalone {
  --ixf-calendar-width: 100%;
  --ixf-calendar-box-shadow: none;
  --ixf-calendar-background: none;
  --ixf-calendar-padding: 0;
}
